import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"keyboard-1"},"children":[{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M4.9996 5C5.55206 5 5.99985 5.44782 6 5.9996C6 6.55185 5.55183 7 4.9996 7C4.44786 6.99992 4 6.55222 4 5.9996C4.00015 5.44745 4.44763 5.00008 4.9996 5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M4.9996 11C5.55206 11 5.99985 11.4478 6 11.9996C6 12.5519 5.55183 13 4.9996 13C4.44786 12.9999 4 12.5522 4 11.9996C4.00015 11.4475 4.44763 11.0001 4.9996 11Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M11.9996 5C12.5521 5 12.9998 5.44782 13 5.9996C13 6.55185 12.5518 7 11.9996 7C11.4479 6.99992 11 6.55222 11 5.9996C11.0002 5.44745 11.4476 5.00008 11.9996 5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M11.9996 11C12.5521 11 12.9998 11.4478 13 11.9996C13 12.5519 12.5518 13 11.9996 13C11.4479 12.9999 11 12.5522 11 11.9996C11.0002 11.4475 11.4476 11.0001 11.9996 11Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M18.9996 5C19.5521 5 19.9998 5.44782 20 5.9996C20 6.55185 19.5518 7 18.9996 7C18.4479 6.99992 18 6.55222 18 5.9996C18.0002 5.44745 18.4476 5.00008 18.9996 5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M18.9996 11C19.5521 11 19.9998 11.4478 20 11.9996C20 12.5519 19.5518 13 18.9996 13C18.4479 12.9999 18 12.5522 18 11.9996C18.0002 11.4475 18.4476 11.0001 18.9996 11Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6 19H18","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Keyboard1 = Vue.extend<IconProps>({
  name: 'Keyboard1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'keyboard-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Keyboard1;
